module.exports = __webpack_public_path__ + "ff198a30fc9fc310b633256e35e1c9aa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owls/owlfonso-green.png
// module id = 1772
// module chunks = 0